import React, { useEffect } from 'react'
import { useRequest } from 'ahooks'

import CopyRight from '@scream/components/CopyRight'
import ToScreamFooter from '@scream/components/ToScreamFooter'

import { getBookDataByID, reportDataFunc } from '@scream/services/shareBookPage'

import ToClipBoard from '@/components/ToClipBoard'
// import bindElementToClipBoard from '@/utils/clip'
import { getLocationVars } from '@/utils/utils'

import './App.scss'

import headerLogo from '@scream/assets/logos/icon_scream.png'
import twitterLogo from '@scream/assets/icons/icon_twitter.png'
import facebookLogo from '@scream/assets/icons/icon_facebook.png'
import copyIcon from '@scream/assets/icons/icon_copy.png'

interface IBookData {
  _id: string
  author_name: string
  book_desc: string
  book_id: string
  book_pic: string
  book_title: string
  read_count: number
  tag: Array<string>
  theme: Array<string>
  update_status: number
  app_icon?: string
}

const getShareText = (title: string) =>
  `I thought you'd be interested in reading "${title}" on Scream. Read it here: `

const App: React.FC = () => {
  const { bookId }: { bookId: string } = getLocationVars()
  const urlQueryParams = getLocationVars()

  const reportData = (action: 1 | 2) =>
    reportDataFunc({
      action,
      bookId,
      randomId: urlQueryParams?.randomId,
      url: location.href
    })
  const { data, error } = useRequest(() => getBookDataByID({ id: bookId }), {
    onSuccess: (res) => {
      if (res.code === 0) reportData(1)
    }
  })

  const bookData: IBookData = data?.data
  const bookUpdateStatus = bookData
    ? bookData?.update_status === 1
      ? 'Complete'
      : 'Ongoing'
    : undefined

  const handlePushToTwitter = () => {
    const url = `https://twitter.com/share?text=${getShareText(
      bookData.book_title
    )}&url=${encodeURIComponent(window.location.href)}`
    window.open(url, '_blank')
  }

  const handlePushToFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      window.location.href
    )}&kid_directed_site=0&title=${getShareText(bookData.book_title)}`
    window.open(url, '_blank')
  }

  const iconsData = [
    {
      key: 'twitter',
      render: (
        <img src={twitterLogo} key='twitter' onClick={handlePushToTwitter} />
      )
    },
    {
      key: 'facebook',
      render: (
        <img src={facebookLogo} key='facebook' onClick={handlePushToFacebook} />
      )
    },
    {
      key: 'copy',
      render: (
        <ToClipBoard key='copy'>
          <img
            id='copy-icon'
            src={copyIcon}
            key='copy'
            style={{ display: 'block' }}
          />
          <></>
        </ToClipBoard>
      )
    }
  ]

  const paragraphList = bookData?.book_desc
    ?.split('\n')
    .filter((paragraphText: string) => !!paragraphText)

  const getReadCountText = (): string => {
    if (!bookData) return ''
    const count = bookData.read_count
    if (count > 1000) {
      if (count < 1000000) {
        if (count % 1000 === 0) {
          return `${Math.floor(count / 1000)}k`
        } else {
          return `${Math.floor(count / 1000)}k+`
        }
      }
      if (count < 1000000000) {
        if (count % 1000000 === 0) {
          return `${Math.floor(count / 1000000)}m`
        } else {
          return `${Math.floor(count / 1000000)}m+`
        }
      }
      return `999m+`
    }
    return `${count}`
  }

  useEffect(() => {
    document.title = bookData?.book_title || ''
  }, [bookData?.book_title])

  if (!bookId) return <>Missing required parameters</>

  if (error) return <>An error has occurred, please try again</>

  if (data?.code !== 0) return <>{JSON.stringify(data?.msg)}</>

  return (
    <div className='page-ctr'>
      <header>
        <img src={headerLogo} alt='' />
      </header>
      <div className='book-data-ctr'>
        <div className='bg-shadow'></div>
        <div
          className='blur-bg'
          style={{
            backgroundImage: bookData?.book_pic
              ? `url(${bookData?.book_pic})`
              : 'none'
          }}
        ></div>
        <div className='content-box'>
          <div className='cover-box'>
            <img src={bookData?.book_pic} alt='' />
          </div>
          <div className='book-data-box'>
            <div className='book-title'>{bookData?.book_title}</div>
            <div className='book-author'>{bookData?.author_name}</div>
            <div className='book-info-box'>
              <div
                className={`book-status ${
                  bookData?.update_status === 1
                    ? 'book-status-completed'
                    : 'book-status-ongoing'
                }`}
              >
                {bookUpdateStatus}
              </div>
              <div className='book-reading'>{getReadCountText()}</div>
              <div className='book-tag'>
                <div>{bookData?.tag?.[0]}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='icons-ctr'>{iconsData.map((item) => item.render)}</div>
      <div className='summary-ctr'>
        <div className='summary-title'>Summary</div>
        <div className='summary-content'>
          {paragraphList?.map((item: string) => (
            <p key={item}>{item}</p>
          ))}
        </div>
      </div>
      <CopyRight />
      <ToScreamFooter
        screamLinkData={urlQueryParams}
        reportData={reportData}
        appIcon={bookData?.app_icon}
        customParamsDic={{ parm1: 'bookId' }}
      ></ToScreamFooter>
    </div>
  )
}

export default App
